import apiClient from '@/utils/api';

export interface DictionaryIssuePayload {
  word: string;
  issueText: string;
  partOfSpeech?: string | null;
  articleId?: string;
  country?: string;
  level?: string;
}

export interface DictionaryIssueResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data?: {
    issueId: string;
  };
}

export interface ArticleIssuePayload {
  articleId: string;
  issueText: string;
  country?: string;
  level?: string;
}

export interface ArticleIssueResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data?: {
    issueId: string;
  };
}

// User management API endpoints
export const userAdminApi = {
  getAllUsers: async () => {
    const response = await apiClient.get('/admin/users');
    return response.data.data;
  },

  getUserById: async (id: string) => {
    const response = await apiClient.get(`/admin/users/${id}`);
    return response.data.data;
  },
  createUser: async (userData: { name: string; email: string; password: string; role: string }) => {
    const response = await apiClient.post('/admin/users', userData);
    return response.data;
  },
  updateUser: async (
    id: string,
    userData: Partial<{ name: string; email: string; role: string }>
  ) => {
    const response = await apiClient.put(`/admin/users/${id}`, userData);
    return response.data;
  },
  deleteUser: async (id: string) => {
    const response = await apiClient.delete(`/admin/users/${id}`);
    return response.data;
  },
};
